module.exports = __webpack_public_path__ + "img/hr-red-pita-08.0d3bfa27.png";